<template>
  <div :data-component-name="$options.name" class="h-100 margins">
    <div :style="styleObject" class="general h-100">
      <div class="div_general">
        <div class="space-between">
          <span
            v-if="content.idJeu != null"
            :class="['progressif ' + content.tailleProgressif + ' ' + content.idJeu]"
          ></span>
          <div>
            <div
              class="surTitre graphik_bold"
              :style="[{ color: content.couleurTitre }]"
              v-html="content.surTitre"
            ></div>
            <div
              class="titre_mediaImage graphik_bold"
              :style="[{ color: content.couleurTitre }]"
              v-html="content.titre"
            ></div>
          </div>

          <b-link
            v-if="content.lien"
            v-bind="jel_getLienBinding(content.lien)"
            class="stretched-link publicite-en-vedette"
            :ga-img-name="imageName"
            :data-tag="`${jel_getNomRouteCourante()} ${content.surTitre} - ${content.titre.replace(
              /&nbsp;/g,
              ' '
            )} - ${content.dataTag}`"
          >
            <div v-if="content.texteBouton">
              <button
                class="btn mt-2 graphik_semibold texteBouton"
                :style="[
                  { 'border-color': content.borderColorBtn },
                  { 'background-color': content.colorBtn },
                ]"
              >
                {{ content.texteBouton }}
              </button>
            </div>
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaImageTit25img50txt25',
  props: { content: { type: Object, required: true } },
  data() {
    return {};
  },
  computed: {
    classObject() {
      return {
        rounded: this.content.coinArrondi,
      };
    },
    imageName() {
      // TODO: M5
      // if (
      //   jel_getFichierSrc(this.content.imageFond) &&
      //   jel_getFichierSrc(this.content.imageFond).indexOf('jcr:') > 0
      // ) {
      //   return jel_getFichierSrc(this.content.imageFond).substring(
      //     parseInt(jel_getFichierSrc(this.content.imageFond).lastIndexOf('/') + 1),
      //     jel_getFichierSrc(this.content.imageFond).length
      //   );
      // }
      return ' ';
    },
    styleObject() {
      return {
        'background-color':
          this.content.fondCouleur?.field != 'defaut'
            ? this.content.fondCouleur.secBgThemeColor
            : null,
      };
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.div_general {
  color: white;
  padding-left: 2%;
  //padding-top:25%;
  margin: -2px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
}

.space-between {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 37%;
}

.surTitre {
  font-size: ms(-3);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}

.titre_mediaImage {
  text-transform: uppercase;
  margin-bottom: 0;
  @include ms-respond(font-size, 0);
}

.btn {
  color: black;
  border-radius: ms(6);
  padding-left: 5%;
  padding-right: 5%;
  margin-bottom: 0.5rem !important;
  font-size: ms(-1);
  font-weight: bold;
  text-transform: uppercase;
  padding-top: 3%;
  padding-bottom: 3%;
  margin-bottom: 1.5rem !important;
}

.btn:hover {
  opacity: 1 !important;
}

.h3 {
  margin-bottom: 0;
}

.coinsArrondis {
  border-radius: ms(1);
}

.margins {
  margin-top: 2rem;
  margin-left: 2rem;
  margin-right: 2rem;
}

.texteBouton {
  margin-top: 0px;
  @include ms-respond(font-size, -1);
}
</style>
